var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-window-list',{attrs:{"headers":_vm.headers,"title":"Listado de Estado de Asignacion","company":_vm.comdes,"addMethod":"itemsEstadoAsignacion","closeBaseWindow":"addEstadoAsignacion","titleAddMethod":"Agregar Estado de Asignacion","itemStoreName":"itemsEstadoAsignacion","loading":_vm.loadingResult,"activarEdicion":true,"activarBorrar":true,"activarInternalForm":true,"formProperties":{
    creacion: 'Creacion de Estado de Asignacion',
    edicion: 'Editar Estado de Asignacion',
    url: `/transjuma/EstadoAsignacion/`
  }},on:{"selected-row":_vm.handleEvent,"updated":_vm.updatedList}})
}
var staticRenderFns = []

export { render, staticRenderFns }